import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import extractText from 'flarum/common/utils/extractText';
/**
 * Names the link around each post's avatar ("Profil de Jplm") for screen
 * readers. Core's CommentPost.avatar() wraps the Avatar in a bare <Link>,
 * named only through the avatar inside it (a role="img" span's aria-label,
 * or an <img>'s alt) - which accessibility checkers don't count as the
 * link's own name: Lighthouse flagged every one on the discussion page
 * (2026-10-12).
 */
export default function labelPostAvatarLinks() {
  extend('flarum/forum/components/CommentPost', 'avatar', function (vnode) {
    const user = this.attrs.post.user();

    // Only the linked case: no user (deleted), no link.
    if (!user || !vnode || typeof vnode !== 'object' || !('attrs' in vnode) || !vnode.attrs || !('href' in vnode.attrs)) return;
    vnode.attrs['aria-label'] = extractText(app.translator.trans('champis-forum.forum.post_avatar_link_label', {
      name: user.displayName()
    }));
  });
}